import Vue from 'vue';

export const EventBus = new Vue();

export class NotificationEventBus {

    public static getEventBus() {
        return EventBus;
    }

    public static emitProcessingMessage() {
        EventBus.$emit('processing-snackbar', {message: 'Committing change'});
    }

    public static emitSuccessMessage() {
        EventBus.$emit('complete-snackbar', {message: 'Change submitted successfully'});
    }

    public static emitFailedMessage(error: any) {
        console.error(error);
        EventBus.$emit('failed-snackbar', {message: error.message});
    }

    public static emitRefreshPublishedScoringData(viewpointId: string) {
        EventBus.$emit('refresh-published-scores', {viewpointId: viewpointId})
    }

    public static emitRefreshSandboxScoringData(viewpointId: string) {
        EventBus.$emit('refresh-sandbox-scores', {viewpointId: viewpointId})
    }

    public static emitRefreshScoringData(viewpointId: string) {
        this.emitRefreshPublishedScoringData(viewpointId);
        this.emitStaleSandboxScoringData(viewpointId);
    }

    public static emitStaleSandboxScoringData(viewpointId: string) {
        EventBus.$emit('stale-sandbox-scores', {viewpointId: viewpointId})
    }

    public static emitStalePublishedScoringData(viewpointId: string) {
        EventBus.$emit('stale-published-scores', {viewpointId: viewpointId})
    }

    public static emitStaleScoringData(viewpointId: string) {
        this.emitStalePublishedScoringData(viewpointId);
        this.emitStalePublishedScoringData(viewpointId);
        EventBus.$emit('stale-scores', {viewpointId: viewpointId})
    }

    public static emitStaleSandboxMetadata(viewpointId: string) {
        EventBus.$emit('stale-sandbox-metadata', {viewpointId: viewpointId})
    }

    public static emitStalePublishedMetadata(viewpointId: string) {
        EventBus.$emit('stale-published-metadata', {viewpointId: viewpointId})
    }

    public static emitStaleMetadata(viewpointId: string) {
        this.emitStaleSandboxMetadata(viewpointId);
        this.emitStalePublishedMetadata(viewpointId);
    }

    public static emitTemplateUpdated(templateId: string) {
        EventBus.$emit('template-published', {templateId: templateId});
    }

    public static emitFactorGroupScoringStale() {
        EventBus.$emit('factor-group-score-stale');
    }

    public static emitChoiceUpdated(choice: any) {
        EventBus.$emit('choice-updated', choice);
    }

    public static emitNotification(event: string, data?: any) {
        EventBus.$emit(event, data);
    }


}